<template>
  <div class="countdown">
    <count-down-num :num="'' + d" :bgColor="bgColor" />
    <div class="countdown-splitor">天</div>
    <count-down-num :num="'' + h" :bgColor="bgColor" />
    <div class="countdown-splitor">小时</div>
    <count-down-num :num="'' + i" :bgColor="bgColor" />
    <div class="countdown-splitor">分钟</div>
    <count-down-num :num="'' + s" :bgColor="bgColor" />
    <div class="countdown-splitor">秒</div>
  </div>
</template>

<script>
import CountDownNum from '@/components/Fund-Count-Down-Num.vue';

export default {
  name: 'count-down',
  props: {
    endTime: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: '#ff0000',
    },
  },
  components: {
    CountDownNum,
  },
  data() {
    return {
      timer: null,
      d: '00',
      h: '00',
      i: '00',
      s: '00',
      leftTime: 0,
      seconds: 0,
    };
  },
  // watch: {
  //   endTime: {
  //     handler: 'render',
  //   },
  // },
  created() {},
  mounted() {
    // this.render();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    render() {
      this.seconds = (new Date(this.endTime.replace(/-/g, '/')).getTime()
          - new Date().getTime())
        / 1000;
      this.countDown();
      this.timer = setInterval(() => {
        this.seconds -= 1;
        if (this.seconds < 0) {
          this.timeUp();
          return;
        }
        this.countDown();
      }, 1000);
    },
    closeTime() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    timeUp() {
      clearInterval(this.timer);
      this.$emit('timeup');
    },
    countDown() {
      const { seconds } = this;
      let [day, hour, minute, second] = [0, 0, 0, 0];

      if (seconds > 0) {
        day = Math.floor(seconds / (60 * 60 * 24));
        hour = Math.floor(seconds / (60 * 60)) - day * 24;
        minute = Math.floor(seconds / 60) - day * 24 * 60 - hour * 60;
        second = Math.floor(seconds)
          - day * 24 * 60 * 60
          - hour * 60 * 60
          - minute * 60;
      } else {
        this.timeUp();
      }

      day = day < 10 ? `0${day}` : day;
      hour = hour < 10 ? `0${hour}` : hour;
      minute = minute < 10 ? `0${minute}` : minute;
      second = second < 10 ? `0${second}` : second;

      this.d = day;
      this.h = hour;
      this.i = minute;
      this.s = second;
    },
  },
};
</script>

<style scoped lang="less">
.countdown {
  padding: 2px 0;
  display: flex;
  align-items: flex-end;
  margin-top: 8px;
  margin-bottom: 25px;

  &-number {
    font-family: DINAlternate-Bold;
    font-size: 72px;
    color: #fff;
    padding: 0 5px;
  }

  &-splitor {
    margin: 0 10px;
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    position: relative;
    top: -10px;
  }
}
</style>
